module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-44.25e1bfe5.png";